import React from "react";
import {
  Label,
  Cell,
  Legend,
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

function rgbToHex(red, green, blue) {
  const rgb = (red << 16) | (green << 8) | (blue << 0);
  return "#" + (0x1000000 + rgb).toString(16).slice(1);
}

const generateColors = (numberOfColors) => {
  const r = 0,
    g = 203,
    b = 255;
  let colors = [];
  let step = 200 / numberOfColors;
  for (let i = 1; i <= numberOfColors; i++) {
    colors.push(rgbToHex(r + step * i, g, b));
  }
  return colors;
};

export default function Chart(props) {
  const { data, show_percentage } = props;
  let colors = generateColors(data.length);

  const renderColorfulLegendText = (value, entry) => {
    const { color, payload } = entry;

    return (
      <span style={{ color }}>
        {show_percentage ? `${(payload.percent * 100).toFixed(0)}% ` : ""}{" "}
        {value} ({payload.value})
      </span>
    );
  };

  return (
    <ResponsiveContainer width={"100%"} aspect={1.7}>
      <PieChart>
        <Tooltip />
        <Pie
          labelLine={false}
          data={props.data}
          style={{ width: "100%" }}
          outerRadius="90%"
          dataKey="value"
          legendType="circle"
          paddingAngle={1}
          nameKey="name"
          cx="50%"
          cy="50%"
          fill="#63c2de"
        >
          {false && <Label dataKey="name" position="top" />}
          {props.data.map((entry, index) => {
            return (
              <Cell fill={colors[index % colors.length]} key={index}></Cell>
            );
          })}
        </Pie>
        <Legend formatter={renderColorfulLegendText} />
      </PieChart>
    </ResponsiveContainer>
  );
}
